export const environment = {
    production: false,
    beBaseUrl: ''
}